import { Link } from "@chakra-ui/react";
import { IconFeatureCard } from "components/cards";
import { ThreeCardGrid } from "components/grids";
import { type IconFeatureProps } from "components/icon-feature";
import React from "react";
import { ConversionEventsIcon } from "./conversion-events-icon";
import { LaunchCampaignsIcon } from "./launch-campaigns-icon";
import { OnboardAudiencesIcon } from "./onboard-audiences-icon";

export function ActivationFeatures() {
  const features: IconFeatureProps[] = [
    {
      icon: OnboardAudiencesIcon,
      title: "Onboard audiences everywhere, instantly",
      description:
        "Get audiences directly from your data source to every major walled garden, DSP, and clean room in minutes. Build your audience, select your destination, and go.",
    },
    {
      icon: ConversionEventsIcon,
      title: "Send conversion events without engineering",
      description: (
        <>
          Easily deploy{" "}
          <Link variant="article" _hover={{ color: "gray.800" }} href="/blog/conversion-apis">
            Conversion API (CAPI) events
          </Link>{" "}
          without engineering. Unlock value-based optimization and smart bidding with calculated conversion values.
        </>
      ),
    },
    {
      icon: LaunchCampaignsIcon,
      title: "Launch campaigns in hours, not days",
      description:
        "No more waiting days or weeks for legacy providers to onboard your data. Sync audiences, set up conversions, and launch campaigns in the same day with lightning-fast data activation.",
    },
  ];

  return (
    <ThreeCardGrid>
      {features.map((feature) => (
        <IconFeatureCard
          key={feature.title}
          variant="gradient"
          gradientColor="green"
          feature={{ mobileJustify: "start", ...feature }}
        />
      ))}
    </ThreeCardGrid>
  );
}
